import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  fill: "#0086FF",
  d: "M19 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-9 14l-5-4.808 1.4-1.346 3.6 3.462L17.6 6 19 7.346 10 16z"
}), 'BoxChecked', {
  viewBox: '0 0 24 22'
});